
export const exportToJson = async (getObjectData, fileName) => {
    const objectData = await getObjectData()
    console.log(objectData)
    const contentType = 'application/json;charset=utf-8;';
    const formattedJson = JSON.stringify(objectData, null, 2); 

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        const blob = new Blob([formattedJson], { type: contentType });
        navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
        const a = document.createElement('a');
        a.download = fileName;
        a.href = `data:${contentType},${encodeURIComponent(formattedJson)}`;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
};
